import { magento, images } from "~/config/extensionsApi";
import { convertImage, encodeId } from "~/helpers";
import { CategoryTree } from "~/composables";
import findDeep from "deepdash/findDeep";
import { MapProductVariant } from "../composables/useElasticSearch/types";
import type { SelectedOption } from "~/modules/catalog/types";

export interface Available {
  uid?: string;
  label?: string;
  value_index?: string;
  swatch_data?: {
    value?: string;
  };
  type?: string;
}

export const getUrlPathByCategory = (row, categoryTree: CategoryTree) => {
  if (row.link) {
    return row.link;
  } else {
    const uid = encodeId(row.category);
    const data = findCategoryByUid(categoryTree, uid);
    const url_path = data?.url_path ?? "";
    return url_path;
  }
};

export const getUrlPathByCategoryId = (id: number, categoryTree: CategoryTree) => {
  const uid = encodeId(id);
  const data = findCategoryByUid(categoryTree, uid);
  const url_path = data?.url_path ?? "";
  return url_path;
};

export function findCategoryByUid(categoryTree: CategoryTree, toFind: string, findBy: keyof CategoryTree = "uid"): CategoryTree | null {
  const categories = categoryTree?.children;

  return categories ? findDeep(categories, (value: string, key: string) => key === findBy && value === toFind)?.parent ?? null : null;
}

/**
 * Checks if a category contains an item with the specified key.
 * @param category - The category array.
 * @param key - The key to check.
 * @returns True if the category contains an item with the specified key, otherwise false.
 */
export const checkLengthDataCategory = (category: any[], key: string | number): boolean => {
  return category?.filter((e) => e.itemPosition == key)?.length > 0 ? true : false;
};

/**
 * Checks if a category has any children.
 * @param categoryChild - The category children array.
 * @returns True if the category has children, otherwise false.
 */
export const checkLength = (categoryChild: any[]): boolean => {
  if (categoryChild?.length > 0) {
    return true;
  } else {
    return false;
  }
};

/**
 * Checks if a category has any raw children.
 * @param category - The category object.
 * @returns True if the category has raw children, otherwise false.
 */
export const checkLengthCategory = (category: { childrenraw?: any[] }): boolean => {
  if (category?.childrenraw?.length > 0) {
    return true;
  } else {
    return false;
  }
};

/**
 * Finds the parent index of an item in a nested data structure.
 * @param data - The data array.
 * @param key - The key to check.
 * @param value - The value to match.
 * @returns The index of the parent item, or -1 if not found.
 */
export const findParent = (data: any[], key: string, value: any): number => {
  for (let i = 0; i < data?.length; i++) {
    const obj = data[i];
    if (obj[key] === value) {
      return i;
    } else if (obj.childrenraw) {
      const index = findParent(obj.childrenraw, key, value);
      if (index !== -1) {
        return i;
      }
    }
  }
  return -1;
};

/**
 * check itemEnable == "1"
 */
export const checkItemEnable = (data) => {
  return data?.filter((e) => e?.itemEnable == "1");
};

export const getThumbnailForCategory = (thumbnail) => {
  if (thumbnail === undefined || thumbnail === "" || thumbnail === null) return "";
  return magento.url + thumbnail;
};

export const setSizeSwatch = (file: string) => {
  if (!file) return "";
  return images.baseUrl + images.cache + images.productSwatch + convertImage(file);
};
export const setSizeProductList = (file: string) => {
  if (!file) return "";
  return images.baseUrl + images.cache + images.productList + convertImage(file);
};
export const setSizeProductDetail = (file: string) => {
  if (!file) return "";
  return images.baseUrl + convertImage(file);
};

export const getBgColorByVariants = (property: Available, variants: MapProductVariant[]) => {
  let color = { "background-image": "#000" };

  if (property && variants) {
    let thumbnailImage;
    thumbnailImage = variants.find((variant) => variant?.color?.toString() === property?.value_index?.toString() && variant?.swatch_thumbnail)?.swatch_thumbnail;
    if (!thumbnailImage) {
      thumbnailImage = variants.find((variant) => variant?.color?.toString() === property?.value_index?.toString() && variant?.thumbnail)?.thumbnail;
    }
    if (!thumbnailImage) {
      thumbnailImage = variants.find((variant) => variant?.color?.toString() === property?.value_index?.toString() && variant?.image)?.image;
    }

    if (thumbnailImage) {
      color = {
        "background-image": `url("${setSizeSwatch(thumbnailImage)}")`,
      };
    } else if (property.swatch_data && property.swatch_data.value) {
      color = {
        "background-image": `url("${setSizeSwatch(property.swatch_data.value)}")`,
      };
    }
  }

  return color;
};

export const getFirstImageByVariants = (selectedColor: Available, variants: MapProductVariant[]) => {
  if (selectedColor) {
    const matchVariants = variants?.filter((variant) => variant?.color?.toString() == selectedColor?.value_index?.toString());

    if (matchVariants.length > 0) {
      const thumbnailImage =
        matchVariants[0]?.thumbnail ||
        matchVariants[0]?.image
      if (thumbnailImage) {
        return setSizeProductList(thumbnailImage);
      }
    }
  } else return "";
};

export const getUrlQuery = (selectedOption: SelectedOption) => {
  if (selectedOption)  {
    let colorLabel = "";
    let sizeLabel = "";
    if (selectedOption?.color) {
       colorLabel = selectedOption?.color?.label;
    }

    if (selectedOption?.size) {
       sizeLabel = selectedOption?.size?.label;
    }
    
    if (colorLabel || sizeLabel) {
      const queryParams = [];
      if (colorLabel) {
        queryParams.push(`color=${encodeURIComponent(colorLabel)}`);
      }
      if (sizeLabel) {
        queryParams.push(`size=${encodeURIComponent(sizeLabel)}`);
      }
      if (queryParams.length > 0) {
        return `?${queryParams.join("&")}`;
      }
    }
  }

 

  return "";
};
